export default "__VITE_ASSET__073453ea__"